export default {
  loadingText: {
    id: 'dashboard_diagnosis_loading_title',
    defaultMessage: 'Ok, letʼs have a closer look…',
  },
}
